// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"3b53517f","38":"3b53517f","51":"3b53517f","52":"3b53517f","232":"3b53517f","452":"3b53517f","474":"3b53517f","492":"3b53517f","530":"3b53517f","712":"490c73c8","818":"3b53517f"}[chunkId] + ".chunk.css";
};